// @flow

import * as React from 'react';

import { localize } from '@ta/common.i18n';
import { Link } from '@ta/common.routing';
import styles from './ShelfHeader.less';

type Props = {
  /** shelf title */
  title: ?string,
  subtitle: ?string,
  /** optional url for 'see all' */
  url: ?string,
  /** callback for clicks into the url, is provided the render prop callback from Mutation and shelf id */
  onClick?: (SyntheticMouseEvent<HTMLElement>) => mixed,
  geoShelfHeader: string,
  geoShelfSeeAll: string,
  clusterId?: string,
};

const ShelfHeader = (props: Props) => {
  const { title, subtitle, url, onClick, geoShelfHeader, geoShelfSeeAll, clusterId } = props;
  let headerStyle;
  if (clusterId) {
    headerStyle = 'ui_cluster_shelf_header_h2';
  } else if (geoShelfHeader !== '') {
    headerStyle = styles.ui_continue_search_header_h2;
  } else {
    headerStyle = '';
  }
  if (url) {
    return (
      <div className={geoShelfHeader === '' ? styles.header_wrap : geoShelfHeader}>
        <div>
          <Link href={url} className={`ui_link ui_header h2 ${headerStyle}`} onClick={onClick}>
            {title}
          </Link>
          {!subtitle ? (
            ''
          ) : (
            <Link href={url} className={`ui_link ${styles.subtitle}`} onClick={onClick}>
              {subtitle}
            </Link>
          )}
        </div>
        <Link
          href={url}
          className={`ui_link ${geoShelfSeeAll === '' ? styles.see_all : geoShelfSeeAll}`}
          onClick={onClick}
        >
          {localize('social_see_more')} {/* See all */}
        </Link>
      </div>
    );
  }
  return (
    <div className={geoShelfHeader === '' ? styles.header_wrap : geoShelfHeader}>
      <span className={`ui_header h2 ${headerStyle}`}>{title}</span>
    </div>
  );
};

ShelfHeader.defaultProps = {
  onClick: undefined,
  clusterId: undefined,
};

export default ShelfHeader;
